import React from 'react';
import cn from 'classnames';
import classNames from 'classnames';

import { useAppSelector } from 'hooks/useRedux';
import Logo from 'layouts/header/Logo';

import headerCss from '../index.module.css';
import classes from './headerWithPB.module.css';

interface Props {
  stickyHeader?: boolean;
}

const HeaderWithProgressBar = ({ stickyHeader }: Props) => {
  const progress = useAppSelector((state) => state.extra.headerProgressBarProgress);

  return (
    <nav className={cn('navbar p-0', headerCss.navbar, {[classes.stickyHeader]: stickyHeader })}>
      <div className={cn('container d-flex flex-nowrap gg-16', headerCss.container)}>
        <Logo userLoggedIn={false} showSmallLogo={false} containerClassName="d-none d-md-block" />

        <div className="d-flex flex-column flex-md-row justify-content-end align-items-center w-100">
          <div className={cn('z-mr-12 z-my-12 z-my-md-0', classes.title)}>Your Progress</div>
          <div className={classes.container}>
            <div className={classes.bar} style={{ width: `${progress}%` }} />
            <div
              className={classes.tick}
              style={{
                left: progress > 94 ? `calc(${progress}% - 24px)` : `${progress}%`,
              }}
            >
              <div className={classes.circle}>
                <div className={classNames('icon-icn-checkbtn', classes.tickImage)} />
              </div>
            </div>
          </div>
          {progress < 100 && (
            <div className={classes.star}>
              <div className={classNames(classes.circle, classes.green)}>
                <div className={classNames('icon-icn-matches', classes.starImage)} />
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default HeaderWithProgressBar;
